// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__XT29X","col":"styles_col__36l_d"};